import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[crm-board-column-header], [crmBoardColumnHeader]',

})
export class CrmBoardColumnHeaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
